"use client"

import { CssBaseline } from "@mui/material"
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles"
import { Stage } from "@tc/env-stage"
import { AlertProvider } from "@tc/ui-dfe/hooks/useAlert"
import { AppProvider } from "@tc/ui-dfe/hooks/useApp"
import { ConfirmProvider } from "@tc/ui-dfe/hooks/useConfirm"
import { ReasonDialogProvider } from "@tc/ui-dfe/hooks/useReasonDialog"
import { SnackbarProvider } from "notistack"
import React, { memo } from "react"
import EnvironmentAlert from "../EnvironmentAlert"
import { AlertSettings } from "./3rd-options"
import theme from "./createTheme"

const isUAT = process.env.NEXT_PUBLIC_UAT === Stage.UAT

export interface ThemeProviderProps {
  children?: React.ReactNode
  nonce?: string
}

export const ThemeProvider = memo((props: ThemeProviderProps) => {
  return (
    <MuiThemeProvider theme={theme}>
      <AppProvider nonce={props.nonce}>
        <CssBaseline />
        <AlertProvider>
          <SnackbarProvider {...AlertSettings}>
            <ReasonDialogProvider>
              <ConfirmProvider>
                {isUAT && (
                  <EnvironmentAlert
                    color="warning"
                    text="Practice Environment"
                  />
                )}
                {props.children}
              </ConfirmProvider>
            </ReasonDialogProvider>
          </SnackbarProvider>
        </AlertProvider>
      </AppProvider>
    </MuiThemeProvider>
  )
})
ThemeProvider.displayName = "ThemeProvider"
